import { render } from "./TermsOfUses.vue?vue&type=template&id=31563d8d&scoped=true"
import script from "./TermsOfUses.vue?vue&type=script&lang=js"
export * from "./TermsOfUses.vue?vue&type=script&lang=js"

import "./TermsOfUses.vue?vue&type=style&index=0&id=31563d8d&lang=scss&scoped=true"

import exportComponent from "/builds/intratone/interface/intratoneinfov4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31563d8d"]])

export default __exports__